// extracted by mini-css-extract-plugin
export default {"notSelected":"box_notSelected__diuaa","selected":"box_selected__ydK9r"};